import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const Collect = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2074_7794)">
      <rect width="6" height="12" transform="matrix(1 0 0 -1 13 24)" fill="currentColor" />
      <path d="M16 4L9 14L23 14L16 4Z" fill="currentColor" />
      <rect x="5" y="26" width="22" height="2" fill="currentColor" />
      <rect width="2" height="4" transform="matrix(-1 0 0 1 28 24)" fill="currentColor" />
      <rect width="2" height="4" transform="matrix(-1 0 0 1 6 24)" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_2074_7794">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'Collect'
);
